import Input from "components/Input";
import PropTypes from 'prop-types';

import { ReactComponent as SignManIcon } from 'icons/components/signMan.svg';
import { ReactComponent as SignWomanIcon } from 'icons/components/signWoman.svg';


export default class InputNameSex extends Input {

    static propTypes = {
        sex: PropTypes.string,
        fname: PropTypes.string,
        reflname: PropTypes.element,
    };
    static defaultProps = {
        sex: null,
        fname: "",
        reflname: null
    };

    constructor(props) {
        super(props);

        this.state = {
            sex: "MALE"
        };

    }

    get value() {
        return this.lnameInput.value;
    }

    set value(value) {
        //this.fnameInput.value = value.fname;
        //return this.lnameInput.value = value.lname;
        if (!value || typeof value !== 'object')
            return;

        this.fnameInput.value = value.fname;
        this.lnameInput.value = value.lname;
    }

    getGender(value) {
        const last = value.toString().slice(-1);
        return (last === "а" || last === "я") ? "FEMALE" : "MALE";
    }

    onToggleSex(sex) {
        this.setState({ sex });
        if (this.props.onClick?.apply)
            this.props.onClick(sex);
    }

    getGenderIcon(sex) {
        return (
            <div className="hand" onClick={this.onToggleSex.bind(this, sex === "FEMALE" ? "MALE" : "FEMALE")}>
                {sex === "FEMALE" ? <SignWomanIcon /> : <SignManIcon />}
            </div>
        );
    }

    onChangefname(fname) {
        this.onToggleSex(this.getGender(fname));
        if (this.props.onChangefname?.apply)
            this.props.onChangefname(fname);
    }

    onChangelname(lname) {
        this.onToggleSex(this.getGender(lname));
        if (this.props.onChangelname?.apply)
            this.props.onChangelname(lname);
    }

    onChangesname(sname) {
        if (this.props.onChangesname?.apply)
            this.props.onChangesname(sname);
    }

    render() {
        //const { sex } = this.state;
        const { fname, sname, lname, sex } = this.props;

        return (
            <div className="inputs flex gap16">
                <Input
                    ref={el => this.lnameInput = el}
                    itemStyle="flex1"
                    label="main.lname"
                    placeHolder="main.lnamePlace"
                    required={true}
                    onChange={this.onChangelname.bind(this)}
                    value={lname}
                />
                <Input
                    ref={el => this.fnameInput = el}
                    itemStyle="flex1"
                    label="main.fname"
                    placeHolder="main.fnamePlace"
                    required={true}
                    onChange={this.onChangefname.bind(this)}
                    iconRight={this.getGenderIcon(sex)}
                    value={fname}
                />
                <Input
                    ref={el => this.snameInput = el}
                    itemStyle="flex1"
                    label="main.sname"
                    placeHolder="main.snamePlace"
                    onChange={this.onChangesname.bind(this)}
                    validator={this._helper.inputValidators.capitalize}
                    value={sname}
                />
            </div>

        );
    }
}
